import React from 'react'

interface InterestProps {
    /** SVG icon style class name */
    size?: string
}

/**
 * Trip Interest svg 
 * Usage : Upload Image Icon.
 * @param props - FR8IconProps
 * @returns ReactJsxElement -> FR8Svg Icon
 */

export const InterestFillSvg: React.FC<InterestProps> = (props) => {
    const {size = "24" } = props

    return (
        <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">

            <path d="M23.7656 8.13719C23.5368 7.87792 23.2555 7.6703 22.9403 7.52812C22.6251 7.38593 22.2833 7.31243 21.9375 7.3125H16.25V5.6875C16.25 4.61006 15.822 3.57675 15.0601 2.81488C14.2983 2.05301 13.2649 1.625 12.1875 1.625C12.0366 1.62489 11.8886 1.66683 11.7601 1.74613C11.6317 1.82542 11.5279 1.93892 11.4603 2.07391L7.62328 9.75H3.25C2.81902 9.75 2.4057 9.92121 2.10095 10.226C1.7962 10.5307 1.625 10.944 1.625 11.375V20.3125C1.625 20.7435 1.7962 21.1568 2.10095 21.4615C2.4057 21.7663 2.81902 21.9375 3.25 21.9375H20.7188C21.3126 21.9377 21.8861 21.7211 22.3315 21.3284C22.777 20.9357 23.0637 20.3939 23.138 19.8047L24.3567 10.0547C24.3999 9.71143 24.3696 9.36291 24.2676 9.03229C24.1657 8.70168 23.9946 8.39655 23.7656 8.13719ZM3.25 11.375H8.9375V20.3125H3.25V11.375Z" fill="#008DD8"/>

            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 11V21L7 20.8947V10.6364L3 11ZM8 10.5455V20.8684L22 20.5L23 8.5L15.5 8C16.1667 6.33333 16.6 3 13 3L8.5 10.5L8 10.5455Z" fill="#008DD8"/>

        </svg>
    )
}
